// Shared account-history links into Lookup. Preserve a known character slot;
// otherwise search by a validated Discord ID or FiveM license.

const HEX = /^[0-9a-f]{40}$/i
const DISCORD = /^\d{15,22}$/

export function stripLicense(value) {
  return String(value || '').trim().replace(/^(license2:|license:|char[1-5]:)/i, '').toLowerCase()
}

export function stripDiscord(value) {
  return String(value || '').trim().replace(/^discord:/i, '')
}

export function playerFilePath({ discord, license, identifier, tab = 'history' } = {}) {
  const qs = new URLSearchParams()
  if (tab) qs.set('tab', tab)
  const d = stripDiscord(discord)
  const hex = stripLicense(license)
  if (identifier && /^char[1-5]:[0-9a-f]{40}$/i.test(String(identifier).trim())) {
    qs.set('id', String(identifier).trim())
    const identQ = DISCORD.test(d) ? d : HEX.test(hex) ? hex : ''
    if (identQ) qs.set('q', identQ)
    return '/staff/player-lookup?' + qs.toString()
  }
  if (DISCORD.test(d)) {
    qs.set('q', d)
    return '/staff/player-lookup?' + qs.toString()
  }
  const fallback = HEX.test(hex) ? hex : stripLicense(identifier)
  if (HEX.test(fallback)) {
    qs.set('q', fallback)
    return '/staff/player-lookup?' + qs.toString()
  }
  return null
}

export function lookupPath(identifier, query) {
  if (!identifier) return '/staff/player-lookup'
  const qs = new URLSearchParams({ id: identifier })
  if (query) qs.set('q', query)
  return '/staff/player-lookup?' + qs.toString()
}
